<div
  [class]="
    'flex rounded-md border border-gray-300 bg-white p-0.5 text-gray-600' +
    widthClass
  ">
  <div class="flex-none">
    <button
      type="submit"
      class="flex h-full flex-wrap content-center px-2"
      (click)="onSearchBtnClicked()">
      <mat-icon>search</mat-icon>
    </button>
  </div>
  <div class="search-flex flex w-full items-center">
    <input
      class="h-8 w-full pr-2 text-sm focus:outline-none focus:ring-0"
      type="search"
      name="search"
      placeholder="{{ 'search' | translate }}"
      [value]="search"
      (change)="onValueChanged($event)"
      (keyup)="isDynamicSearch && onValueChanged($event)"
      (keyup.enter)="onSearchBtnClicked()" />
    <mat-icon class="search-x" (click)="onXClicked()">close</mat-icon>
  </div>
</div>
